import * as pages from 'interview/pages'
import App from 'interview/app'
import SequencedInterview from 'interview/components/sequenced-interview'
import Interview from 'interview/components/interview'
import SequencedInterviewQuestions from 'interview/components/sequenced-interview/sequenced-interview-questions'
import NetworkTest from 'interview/components/sequenced-interview/network-test'
import Error404 from 'components/errors/404'
import Error403 from 'components/errors/403'
import { enableNewEmbeddedProfileInterview } from 'flags'
import { parse as qs } from 'qs'

export default onEnter => [
  {
    component: App,
    childRoutes: [
      {
        path: '/interview/linked-in/callback',
        onEnter: (routerState, redirect) => {
          let { search } = routerState.location
          if (search[0] === '?') {
            search = search.substring(1)
          }
          const query = qs(search)
          const jobOpeningId = window.sessionStorage.getItem(
            'interviewJobOpeningPublicUuid'
          )
          const csrfToken = window.sessionStorage.getItem('interviewCsrf')
          const { error, code } = query
          const returnedCsrfToken = query.state

          window.sessionStorage.removeItem('interviewJobOpeningPublicUuid')
          window.sessionStorage.removeItem('interviewCsrf')

          if (csrfToken !== returnedCsrfToken || !jobOpeningId) {
            redirect('/careers/403')
          } else if (error) {
            redirect(`/interview/public/${jobOpeningId}?linkedInError=${error}`)
          } else {
            redirect(`/interview/public/${jobOpeningId}?linkedInCode=${code}`)
          }
        },
      },
      {
        path: '/enter/finished',
        component: pages.Finished,
        onEnter,
      },
      {
        path: '/enter/:token',
        component: pages.Index,
        onEnter,
        indexRoute: {
          component: Interview,
        },
        childRoutes: [
          {
            path: '/enter/:token/withdraw',
            component: pages.Withdraw,
            onEnter,
          },
        ],
      },
      {
        path: '/sequenced-interview/finished',
        component: pages.Finished,
        onEnter,
      },
      {
        path: 'sequenced-interview/closed',
        component: pages.Closed,
        onEnter,
      },
      {
        path: '/sequenced-interview/:token',
        component: pages.SequencedInterviewPage,
        onEnter,
        indexRoute: {
          component: SequencedInterview,
        },
        childRoutes: [
          {
            path: '/sequenced-interview/:token/test',
            component: NetworkTest,
            onEnter,
          },
          {
            path: '/sequenced-interview/:token/questions',
            component: SequencedInterviewQuestions,
            onEnter,
          },
          {
            path: '/sequenced-interview/:token/withdraw',
            component: pages.Withdraw,
            onEnter,
          },
        ],
      },
      {
        path: '/interview/public/:uuid',
        component: pages.PublicInterview,
        onEnter,
      },
      {
        path: '/interview/personal/:id',
        component: pages.PersonalInterview,
        onEnter,
      },
      enableNewEmbeddedProfileInterview()
        ? {
            path: '/interview/profile/closed',
            component: pages.Closed,
            onEnter,
          }
        : {},
      enableNewEmbeddedProfileInterview()
        ? {
            path: '/interview/profile/:token',
            component: pages.EmbeddedProfileInterview,
            onEnter,
          }
        : {},
      {
        path: '/interview/embedded/closed',
        component: pages.Closed,
        onEnter,
      },
      {
        path: '/interview/embedded/:token',
        component: pages.EmbeddedInterview,
        onEnter,
      },
      {
        path: '/interview/messages/:context/:token',
        component: pages.Messages,
        onEnter,
      },
      {
        path: '/closed',
        component: pages.Closed,
        onEnter,
      },
      {
        path: '/:context/:token/unpublished',
        component: pages.Unpublished,
        onEnter,
      },
      {
        path: '/public/closed',
        component: pages.Closed,
        onEnter,
      },
      {
        path: '/saved',
        component: pages.Saved,
        onEnter,
      },
      {
        path: '/403',
        component: Error403,
        onEnter,
      },
      {
        path: '*',
        component: Error404,
      },
    ],
  },
]
